import '@fontsource/manrope/cyrillic-ext-400.css';
import '@fontsource/manrope/cyrillic-ext-500.css';
import '@fontsource/manrope/cyrillic-ext-600.css';
import '@fontsource/manrope/cyrillic-ext-700.css';
import '@fontsource/manrope/latin-400.css';
import '@fontsource/manrope/latin-500.css';
import '@fontsource/manrope/latin-600.css';
import '@fontsource/manrope/latin-700.css';
import '@fontsource/prata/cyrillic-ext-400.css';
import '@fontsource/prata/latin-400.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { LocaleProvider } from './features/i18n/LocaleProvider';
import { AuthProvider } from './features/auth/AuthProvider';
import { startPwaSupport } from './features/pwa/install';
import { router } from './app/router';
import './styles/global.css';

startPwaSupport();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LocaleProvider>
          <RouterProvider router={router} />
        </LocaleProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
